import tokenConfig from './token_config.json';

// Type definitions
export type TokenConfig = {
  id: string;
  coinGeckoId: string;
  code: string;
  issuer: string;
  description: string;
  icon: string;
};

export type NetworkConfig = {
  name: string;
  tradingPairs: {
    baseTokenIds: string[];
    quoteTokenIds: string[];
  };
  tokens: TokenConfig[];
};

export type TokenConfigFile = {
  networks: {
    [networkId: string]: NetworkConfig;
  };
};

// Load configuration from JSON
const config = tokenConfig as TokenConfigFile;

// Export individual token constants for backwards compatibility
export const XRP_MAINNET_TOKEN = config.networks['xrpl:0'].tokens.find(t => t.id === 'xrp-mainnet')!;
export const RLUSD_MAINNET_TOKEN = config.networks['xrpl:0'].tokens.find(t => t.id === 'rlusd-mainnet')!;
export const ACGBT_MAINNET_TOKEN = config.networks['xrpl:0'].tokens.find(t => t.id === 'acgbt-mainnet')!;

export const XRP_TESTNET_TOKEN = config.networks['xrpl:1'].tokens.find(t => t.id === 'xrp-testnet')!;
export const RLUSD_TESTNET_TOKEN = config.networks['xrpl:1'].tokens.find(t => t.id === 'rlusd-testnet')!;
export const ACGBT_TESTNET_TOKEN = config.networks['xrpl:1'].tokens.find(t => t.id === 'acgbt-testnet')!;

// Export TOKEN_MAP for backwards compatibility
export const TOKEN_MAP: Record<string, TokenConfig[]> = {
  'xrpl:0': config.networks['xrpl:0'].tokens,
  'xrpl:1': config.networks['xrpl:1'].tokens,
};

// Export the full configuration
export const TOKEN_CONFIG = config;

// Helper function to get network config
export function getNetworkTokenConfig(networkId: string): NetworkConfig | undefined {
  return config.networks[networkId];
}
